function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React, { PureComponent, memo } from 'react';
import PropTypes from 'prop-types';
import camelCase from 'lodash/camelCase';
import hash from 'object-hash';
import { parseSync as parseSvg } from 'svgson';
import componentPropType from '@signal/prop-types/component';
import isTest from '@signal/utils/env/isTest';
import generateGuid from '@signal/utils/generateGuid';
import renderIf from '@signal/utils/renderIf';
import { SignalSvg, SignalSvgPropTypes } from './createSvgIcon';
/*
 * hydration utility functions
 */

var nextTestId = 1;
/**
 * this function cooks the ids an SVG string before hydration.  It generates guids for all ids embedded in the SVG,
 * to prevent collisions with other ids on the page.  Webpack does something similar for SVGs compiled at build time
 * @param {String} svgString - the SVG markup, as a string
 * @return {String} - the SVG markup, with all IDs replaced as guids
 */

export function cookSvgStringIds(svgString) {
  // find all internal ids and randomize their names, since they often have single-character names
  // this is to avoid collisions with other things on the page, including other SVGs
  var idMatches = svgString.match(/id=["'][^'"]+["']/g);
  if (!idMatches) return svgString;
  return idMatches.reduce(function (str, match) {
    var guid = isTest() ? "test".concat(nextTestId++) : generateGuid(); // generate better unique id

    var quoteChar = match[3]; // single quote or double quote?

    match = match.substring(4, match.length - 1); // extract the ID from inside id="..."
    // replace the actual id= with the new guid

    str = str.replace(new RegExp("id=".concat(quoteChar).concat(match).concat(quoteChar), 'g'), "id=".concat(quoteChar).concat(guid).concat(quoteChar)); // replace any references to th old id, which should in all cases have a leading # and immediately be followed
    // by a quote or close parenthesis

    var endingChars = [quoteChar, '\\)'];
    endingChars.forEach(function (endChar) {
      str = str.replace(new RegExp("#".concat(match).concat(endChar), 'g'), "#".concat(guid).concat(endChar.replace(/\\/g, '')) // parenthesis is a special regex char, need to remove escape chars
      );
    });
    return str;
  }, svgString);
}
/**
 * this function camelizes all attribute names which React requires to be camelized before they hit the DOM, which
 * is any non aria- or non data- attribute, including all namespaced attributes
 * See https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html
 * @param {Object} attributes - attributes for this SVG element, as yielded by the SVG parser
 * @return {Object} - the same attributes object as passed in, except all keys which need to be camelized will be
 */

export function camelizeAttributes(attributes) {
  return Object.keys(attributes).reduce(function (sanitized, key) {
    var camelizedKey = camelCase(key);

    if (camelizedKey !== key && !key.startsWith('aria-') && !key.startsWith('data-')) {
      sanitized[camelizedKey] = attributes[key];
      delete sanitized[key];
    }

    return sanitized;
  }, attributes);
}
/*
 * classes/functions below this line generate hydrated React SVG markup
 */
// a special error which can be thrown if the SVG cannot be parsed/hydrated

var CouldNotHydrateSvgError = /*#__PURE__*/function (_Error) {
  _inherits(CouldNotHydrateSvgError, _Error);

  var _super = _createSuper(CouldNotHydrateSvgError);

  function CouldNotHydrateSvgError(svgString, originalError) {
    var _this;

    _classCallCheck(this, CouldNotHydrateSvgError);

    _this = _super.call(this, "Could not parse SVG string: ".concat(svgString, ".\r\nSupply an ErrorIcon to avoid this exception"));
    _this.name = _this.constructor.name;
    _this.svgString = svgString;
    _this.originalError = originalError;
    return _this;
  }

  return CouldNotHydrateSvgError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * this function recursively generates React DOM elements from the object yielded by the SVG parser
 * @param {Object} svgObj - an object returned from the SVG parser
 * @param {Number} index - index of this element compared to siblings
 * @return {React.Element} - a React DOM tree recursively generated from the SVG parser results
 */


function hydrateSvg(_ref, index) {
  var attributes = _ref.attributes,
      children = _ref.children,
      name = _ref.name;
  return /*#__PURE__*/React.createElement(name, _objectSpread({
    className: attributes.fill ? undefined : 'fill',
    // allow manipulation by fillColor unless it specifies a fill
    key: "".concat(index, "_").concat(hash(attributes))
  }, camelizeAttributes(attributes)), children.map(function (props, index) {
    return hydrateSvg(props, index);
  }));
}
/**
 * this function returns a React component that can be passed to an MUI SVG component property from an SVG string.
 * It parses the provided SVG string and returns a React component that merges the properties passed to the SVG
 * component (for controlling things like size, color, etc) with the root properties of the SVG element as provided by
 * the SVG parser.
 * @param {String} svgString - the SVG markup, as a string
 * @return {React.Component} - a React Component which can render the hydrated SVG markup
 */


function getHydratedSvg(svgString) {
  var cookedSvgString = cookSvgStringIds(svgString);

  var HydratedSvg = function HydratedSvg(props) {
    var svgObj = parseSvg(cookedSvgString);
    var _svgObj$attributes = svgObj.attributes,
        height = _svgObj$attributes.height,
        width = _svgObj$attributes.width;

    if (height && height.toString() !== '24' || width && width.toString() !== '24') {
      // we don't support icons which specify width/height different than 24x24
      throw new CouldNotHydrateSvgError(svgString);
    }

    svgObj.attributes = _objectSpread(_objectSpread({}, svgObj.attributes), props);
    return hydrateSvg(svgObj, 0);
  };

  return /*#__PURE__*/memo(HydratedSvg);
} // this class can render an SVG icon hydrated from a string.  It supports an optional ErrorIcon that can be rendered
// if the provided string cannot be parsed/hydrated


var HydratedSvgIcon = /*#__PURE__*/function (_PureComponent) {
  _inherits(HydratedSvgIcon, _PureComponent);

  var _super2 = _createSuper(HydratedSvgIcon);

  function HydratedSvgIcon() {
    var _this2;

    _classCallCheck(this, HydratedSvgIcon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "state", {
      useErrorIcon: false
    });

    return _this2;
  }

  _createClass(HydratedSvgIcon, [{
    key: "componentDidCatch",
    value: function componentDidCatch(err) {
      var _this$props = this.props,
          svgString = _this$props.svgString,
          ErrorIcon = _this$props.ErrorIcon;

      if (ErrorIcon) {
        console.error('could not parse the following SVG string, using error icon');
        console.error(svgString);
        this.setState({
          useErrorIcon: true
        });
      } else {
        throw new CouldNotHydrateSvgError(svgString, err);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          svgString = _this$props2.svgString,
          ErrorIcon = _this$props2.ErrorIcon,
          rest = _objectWithoutProperties(_this$props2, ["svgString", "ErrorIcon"]);

      var useErrorIcon = this.state.useErrorIcon;
      return renderIf(useErrorIcon, function () {
        return /*#__PURE__*/React.createElement(ErrorIcon, rest);
      }, /*#__PURE__*/React.createElement(SignalSvg, Object.assign({}, rest, {
        component: getHydratedSvg(svgString)
      })));
    }
  }]);

  return HydratedSvgIcon;
}(PureComponent);

HydratedSvgIcon.propTypes = _objectSpread(_objectSpread({}, SignalSvgPropTypes), {}, {
  svgString: PropTypes.string.isRequired,
  ErrorIcon: componentPropType
});
export default HydratedSvgIcon;